import { Typography, type SxProps, type Theme, type TypographyProps } from '@mui/material';
import { mergeSx } from '../../../../utils/styles';

const styles = {
  heading: {
    typography: 'h4',
    color: 'neutral.50',
    fontWeight: 700,
    letterSpacing: 0,
    lineHeight: 1,
    mb: 1.25,
  },
} as const;

type NeobetFooterHeadingProps = {
  children: TypographyProps['children'];
  component?: TypographyProps['component'];
  sx?: SxProps<Theme>;
};

const NeobetFooterHeading = ({ children, component = 'h2', sx }: NeobetFooterHeadingProps) => (
  <Typography component={component} sx={mergeSx(styles.heading, sx)}>
    {children}
  </Typography>
);

export default NeobetFooterHeading;
